import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  assetDataService,
  riskDataService,
  assetSharedModelService,
  riskSharedModelService,
} from 'app/services';
import {
  alerts,
  actionIcon,
  importDocument
} from 'app/components/global';
import assetsByType from './assetsByType';
import editAssetDialog from './dialog.editAssetDialog';
import controller from './asset-admin.controller';
import directive from './asset-admin.directive';
import assetAdminSettingsDialog from './dialog.settingsDialog';

export const assetAdminRouteConfig = {
  template: require('./asset-admin.html'),
  controller: 'AssetAdminController',
  controllerAs: 'assetAdminVM',
};

export default angular.module('app.components.admin.assetAdmin', [
  alerts,
  actionIcon,
  editAssetDialog,
  loaderService,
  ssDialogService,
  assetDataService,
  riskDataService,
  assetSharedModelService,
  riskSharedModelService,
  assetAdminSettingsDialog,
  importDocument,
  assetsByType,
])
  .directive('assetAdmin', directive)
  .controller('AssetAdminController', controller)
  .name;

console.log('app.components.admin.assetAdmin created');
